var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoItalic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM11.8279 4.5C11.8279 5.32843 11.1563 6 10.3279 6C9.49942 6 8.82785 5.32843 8.82785 4.5C8.82785 3.67157 9.49942 3 10.3279 3C11.1563 3 11.8279 3.67157 11.8279 4.5ZM7.479 9H9.1227L8.10534 14.0928C7.91311 15.117 8.39047 16.1506 9.29483 16.6684C10.1658 17.167 11.2529 17.0834 12.0374 16.4574L12.0787 16.4244C12.5521 16.0467 12.874 15.5114 12.9857 14.9162L13.2415 13.5532H11.2066L11.02 14.5473C10.9968 14.6711 10.9298 14.7825 10.8313 14.8611L10.7899 14.8941C10.6465 15.0086 10.4477 15.0239 10.2885 14.9327C10.1231 14.838 10.0359 14.649 10.071 14.4618L11.3107 8.18447C11.3656 7.89206 11.2874 7.5904 11.0974 7.36144C10.9074 7.13248 10.6254 7 10.3279 7H7.979L7.479 9Z",
    fill: "white",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoItalic);
export default __webpack_public_path__ + "static/media/info-italic.df634490b43f0950c3b470e7186b255a.svg";
export { ForwardRef as ReactComponent };